module.exports = __webpack_public_path__ + "assets/img/c44f78051f201536792736d597ed815f.png";